<template>
  <div>
    <div v-loading="true"></div>
  </div>
</template>

<script>
import { oidcSettings } from '../../auth/config';
//import { UserManager } from 'oidc-client';

export default {
  methods: {
    tryLoginStudent() {
      const settings = oidcSettings();

      //var mgr = new UserManager(settings);

      let params = `?client_id=${settings.client_id}`;
      params += `&redirect_uri=${settings.redirect_uri}`;
      params += `&response_type=${settings.response_type}`;
      params += `&scope=${settings.scope}`;
      params += `&nonce=${this.generateNonce(32)}`;
      const studentLoginUrl = `${
        settings.authority
      }/account/studentlogin?ReturnUrl=/connect/authorize/callback${encodeURIComponent(
        params
      )}`;

      setTimeout(() => {
        window.location.href = studentLoginUrl;
      }, 1000);
    },

    generateNonce(len) {
      const hex = '0123456789ABCDEF';
      let output = '';
      for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length));
      }
      return output;
    }
  },

  created() {
    this.tryLoginStudent();
  }
};
</script>
